<div class="container-fluid">
    <div class="row">
        <app-breadcrumb [childLink]="childLinkLabel" [subchildLink]="subchildLinkLabel"></app-breadcrumb>
    </div>
    <div class="image-container">
        <img class="access-denied-image" src="/assets/images/access_denied.png">
    </div>
</div>